import axios from 'axios';

const useSaveCostAssumptions = () => {
  return async ({ estimateId, assumptions }) => {
    if (!estimateId) throw new Error('Estimate ID is required.');

    const payload = assumptions.map((item) => ({
      estimateId,
      type: item.type,
      value: item.value != null ? parseFloat(item.value) : null,
    }));

    await axios.put(`/api/PipelinePricing/update-cost-assumptions/${estimateId}`, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
  };
};

export default useSaveCostAssumptions;
